import { useCallback, useContext, useEffect, useState } from "react";

import Grid from "@material-ui/core/Grid";

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer } from "./styles/Cliente";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import Btn from "../../../components/buttons/Btn";
import AccordionClienteDadoGeral from "./children/AccordionClienteDadoGeral";
import AccordionClienteContato from "./children/AccordionClienteContato";
import AccordionClienteEndereco from "./children/AccordionClienteEndereco";
import AccordionClienteAutorizado from "./children/AccordionClienteAutorizado";
import AccordionClienteRelacionado from "./children/AccordionClienteRelacionado";
import useClienteController from "./controllers/ClienteController";
import {
  ClienteContext,
  ClienteContextProvider,
} from "./contexts/ClienteContext";
import AccordionClienteInfoComercial from "./children/AccordionClienteInfoComercial";
import AccordionClienteTabelaPreco from "./children/AccordionClienteTabelaPreco";
import AccordionClienteInfoFinanceira from "./children/AccordionClienteInfoFinanceira";
import AccordionClienteOutrasInfo from "./children/AccordionClienteOutrasInfo";
import { findRegiaoComerciais } from "../../../repositories/qerpapi/erp/prouser/v1/RegiaoComerciaisRepository";
import { findTransportadoras } from "../../../repositories/qerpapi/erp/prouser/v1/TransportadorasRepository";
import { findCliente } from "../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { findVendedores } from "../../../repositories/qerpapi/erp/vendas/v1/VendedoresRepository";
import MaskService from "../../../utils/mask/maskService";
import { findParceirosComerciais } from "../../../repositories/qerpapi/erp/prouser/v1/ParceirosComerciais";
import { findTipoPagamento } from "../../../repositories/qerpapi/erp/prouser/v1/TipoPagamento";
import { findBancos } from "../../../repositories/qerpapi/v3/BancosRepository";
import { findTabelaFrete } from "../../../repositories/qerpapi/erp/prouser/v1/TabelaFreteRepository";
import { findClasseRisco } from "../../../repositories/qerpapi/erp/prouser/v1/ClasseRiscosRepository";
import { findEmpresasV2 } from "../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import { findTabelaPrecos } from "../../../repositories/qerpapi/erp/prouser/v1/TabelaPrecos";
import { formatDate } from "../../../utils/formatDate";
import AccordionRuralEstablishment from "./children/AccordionRuralEstablishment";
import { checkAccountant } from "../../../repositories/qerpapi/v3/ClienteRepository";
import { validarCNPJ, validarCPF } from "../../../utils/validations";
import { GlobalVariables } from "../../../GlobalVariables";

const View = ({ location }) => {
  const {
    handleSubmit,
    clearCutomerContext,
    handleBackSubmit,
    handleAddRelationship,
    handleFindShippingCompany,
  } = useClienteController();

  const { queryParams } = useContext(QueryParamsContext);

  const {
    listUf,
    setListUf,
    listNation,
    listSalesMan,
    setListSalesMan,
    listCommercialPartner,
    setListCommercialPartner,
    listDefaultPayment,
    setListDefaultPayment,
    listTypePayment,
    setListTypePayment,
    listTableShipping,
    setListTableShipping,
    setExpanded,
    setListShippingCompany,

    //Dados Gerais
    setGeneralWebsite,
    generalCustomerId,
    setGeneralCustomerId,
    setGeneralTypeSubscription,
    setIsEmptyCpfCnpj,
    setGeneralCpfCnpj,
    setGeneralName,
    setGeneralFantasy,
    setGeneralCep,
    setGeneralAddress,
    setGeneralNewAddress,
    setGeneralNumber,
    setGeneralComplement,
    setGeneralDistrict,
    setGeneralUf,
    setGeneralCounty,
    setGeneralNation,
    setGeneralTelephone1,
    setGeneralTelephone2,
    setGeneralTelephone3,
    setGeneralEmail,
    setGeneralRg,
    setGeneralIe,
    setGeneralMatriz,
    setGeneralSimpleNational,
    setGeneralFinalCustomer,
    setGeneralIm,
    setGeneralCcm,
    setGeneralIsuf,
    setGeneralCheckBudget,
    setGeneralCheckNfe,
    setGeneralCheckFinancial,
    setGeneralActive,
    setGeneralIeIndication,
    setGeneralSendEmail,
    setGeneralDateInitial,
    ruralProducer,
    setGeneralSendHub,
    setValidCpfCnpj,

    //Endereços
    setBillingCep,
    setBillingAddress,
    setBillingComplement,
    setBillingNewAddress,
    setBillingNumber,
    setBillingCounty,
    setBillingUf,
    setBillingDistrict,
    setDeliveryAddress,

    //Contatos
    setContacts,

    //Autorizados
    setAuthorized,

    //Tabela Preco Cliente
    setCustomerPriceTable,

    //Relacionados
    setMainCustomer,
    setDependentCustomer,
    setRelationship,

    //Info. Comerciais
    setSalesman,
    setCommercialPartner,
    defaultPayment,
    setDefaultPayment,
    setTypePayment,
    setTableShipping,
    setShippingDiscount,
    setDefaultDiscount,
    setShippingCompany,
    setCommercialRegion,
    setIrWithheld,
    setIssWithheld,
    setCommercialRegionSelect,
    listCommercialRegion,
    setInvertDiscount,

    //Info. Financeiras
    setHasRestriction,
    setHasLimit,
    setLastSearchSerasa1,
    setLastSearchSerasa2,
    setLastSearchSerasa3,
    setLimitValue,
    setGenerateCommission,
    setRiskClass,
    setFinancialObservation,
    setBillingAlert,
    setBankInformations,

    //Outras informações
    setOtherOwnHome,
    setOtherBirthDate,
    setOtherFathersName,
    setOtherRgFather,
    setOtherCpfFather,
    setOtherMothersName,
    setOtherRgMother,
    setOtherCpfMother,
    setOtherAdditionalData,
    setOtherCompanyName,
    setOtherIssueDate,
    setOtherRemuneration,
    setOtherRole,
    setOtherTelephone,
    setOtherCounty,
    setOtherAddress,
    setOtherTypeResidence,
    setOtherTimeResidence,
    setOtherFamilyIncome,
    setOtherPersonalReference,
    setOtherCommercialReference,
    setOtherNoteNfe,
    setOtherPartners,

    //Dados do Cônjuge
    setSpousesName,
    setSpousesBirthDate,
    setSpousesTelephone,
    setSpousesRg,
    setSpousesCpf,
    setSpousesCompany,
    setspousesAdmissionDate,
    setSpousesRole,
    setSpousesRemuneration,
    setSpousesCounty,
    setSpousesAddress,

    setLoadingInputs,
    loading,
    setLoading,
    setListCommercialRegion,
    setListRiskClass,
    listRiskClass,
    listCounty,
    setListCounty,
    setListBank,
    listCompany,
    setListCompany,
    setListPriceTable,

    setShowPlugAdd,
    setRuralProducer,
    setRuralEstablishment,
  } = useContext(ClienteContext);
  const [dataCustomerEdit, setDataCustomerEdit] = useState({});

  useEffect(() => {
    setExpanded({ general: true });
  }, [setExpanded]);

  useEffect(() => {
    if (!queryParams.empresa_cnpj) return;

    async function getLists() {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listCommercialRegion: true,
          listCompany: true,
          listSalesMan: true,
          listCommercialPartner: true,
          listDefaultPayment: true,
          listBank: true,
          listTableShipping: true,
          listShippingCompany: true,
          listRiskClass: true,
          listPriceTable: true,
        }));

        setLoading(true);
        const [
          resultCommercialRegion,
          resultCompanies,
          resultSalesMan,
          resultCommercialPartner,
          resultDefaultPayment,
          resultBank,
          resultTableShipping,
          resultShippingCompany,
          resultRiskClass,
          resultPriceTable,
          resultCustomerCheckAccountant,
        ] = await Promise.all([
          findRegiaoComerciais(queryParams.empresa_cnpj),
          findEmpresasV2(queryParams.empresa_cnpj),
          findVendedores({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: { ativo: "S" },
          }),
          findParceirosComerciais({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: { "%ativo%": "S" },
          }),
          findTipoPagamento(queryParams.empresa_cnpj, {}, "empresasformaspgto"),
          findBancos(),
          findTabelaFrete(queryParams.empresa_cnpj),
          findTransportadoras(queryParams.empresa_cnpj),
          findClasseRisco(queryParams.empresa_cnpj),
          findTabelaPrecos(queryParams.empresa_cnpj),
          checkAccountant({
            document: queryParams.empresa_cnpj,
          }),
        ]);

        if (resultCompanies.success) setListCompany(resultCompanies.data);

        if (resultCommercialRegion.success)
          setListCommercialRegion(resultCommercialRegion.data);

        if (resultSalesMan.success) setListSalesMan(resultSalesMan.data);

        if (resultCommercialPartner.success)
          setListCommercialPartner(resultCommercialPartner.data);

        if (resultDefaultPayment.success)
          setListDefaultPayment(resultDefaultPayment.data);

        if (resultBank.success) setListBank(resultBank.data);

        if (resultTableShipping.success)
          setListTableShipping(resultTableShipping.data);

        if (resultShippingCompany.success)
          setListShippingCompany(resultShippingCompany.data);

        if (resultRiskClass.success) setListRiskClass(resultRiskClass.data);

        if (resultPriceTable.data) setListPriceTable(resultPriceTable.data);

        setShowPlugAdd(resultCustomerCheckAccountant?.data?.isAccountant);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setLoadingInputs((current) => ({
          ...current,
          listCommercialRegion: false,
          listCompany: false,
          listSalesMan: false,
          listCommercialPartner: false,
          listDefaultPayment: false,
          listBank: false,
          listTableShipping: false,
          listShippingCompany: false,
          listRiskClass: false,
          listPriceTable: false,
        }));
      }
    }
    getLists();
  }, [
    queryParams.empresa_cnpj,
    setListCommercialRegion,
    setLoadingInputs,
    setListBank,
    setListCommercialPartner,
    setListCompany,
    setListCounty,
    setListDefaultPayment,
    setListRiskClass,
    setListSalesMan,
    setListShippingCompany,
    setListTableShipping,
    setListUf,
    setListPriceTable,
    setShowPlugAdd,
    setLoading,
  ]);

  useEffect(() => {
    if (!defaultPayment) return;

    setListTypePayment(defaultPayment?.empresasformaspgto || []);
  }, [defaultPayment, setListTypePayment]);

  useEffect(() => {
    if (!queryParams.empresa_cnpj) return;

    const customerId =
      location?.state?.item?.id || queryParams?.cliente_id || null;

    if (!customerId) {
      clearCutomerContext();
      return;
    }

    setGeneralCustomerId(customerId);
    (async () => {
      try {
        setLoading(true);

        const dataCustomer = await findCliente({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: customerId,
          include:
            "clientesautorizados,clientescontatos,clientesentregas,clientessocios,contasbancarias,titulares,dependentes,tabelapreco,estabelecimentosRurais,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco",
          trashedInclude:
            "estabelecimentosRurais,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco",
        });

        if (!dataCustomer.success || !dataCustomer.data) {
          return;
        }

        const { data } = dataCustomer;
        data.idcategoria =
          data.idcategoria ??
          (data.cpfcnpj?.replace(/[^0-9]+/g, "").length === 14 ? "2" : "1");
        setDataCustomerEdit(data);

        //Dados Gerais

        const cpfOrCnpj =
          (data?.cpfcnpj || "").replace(/[^0-9]+/g, "").length === 11
            ? "cpf"
            : "cnpj";

        if (cpfOrCnpj === "cpf") {
          setValidCpfCnpj(validarCPF(data?.cpfcnpj || ""));
        } else {
          setValidCpfCnpj(validarCNPJ(data?.cpfcnpj || ""));
        }

        setGeneralTypeSubscription(
          data.idcategoria === "1"
            ? { description: "CPF", value: "cpf" }
            : { description: "CNPJ", value: "cnpj" }
        );
        setGeneralActive(data.ativo === "S");
        setIsEmptyCpfCnpj(data.cpfcnpj ? false : true);
        setGeneralCpfCnpj(
          data.cpfcnpj ? MaskService.toMask(cpfOrCnpj, data.cpfcnpj) : ""
        );
        setGeneralName((data.razao || "").substring(0, 50));
        setGeneralFantasy((data.apelido || "").substring(0, 20));
        setGeneralCep(MaskService.toMask("cep", data.cep || ""));
        setGeneralNewAddress((data.endereco || "").split(",")[0] || "");
        setGeneralNumber(
          (data.endereco || "").split(",").length > 0
            ? (data.endereco || "").split(",")[1]
            : ""
        );
        setGeneralComplement(data.complemento || "");
        setGeneralDistrict(data.bairro || "");
        setGeneralTelephone1(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd1 || ""}${data.telefone1 || ""}`
          )
        );
        setGeneralTelephone2(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd2 || ""}${data.telefone2 || ""}`
          )
        );
        setGeneralTelephone3(
          MaskService.toMask(
            "cel-phone",
            `${data.ddd3 || ""}${data.telefone3 || ""}`
          )
        );
        setGeneralEmail(data.email || "");
        setGeneralIe(data.ie || "");
        setGeneralRg(MaskService.toMask("rg", data.rg || ""));
        setGeneralSimpleNational(data.simples_nacional === "S");
        setGeneralFinalCustomer(data.consumidorfinal === "1");
        setGeneralIm(data.inscricao_municipal || "");
        setGeneralCcm(data.ccm || "");
        setGeneralIsuf(data.isuf || "");
        setGeneralIeIndication(
          [
            { label: "Contribuinte ICMS", value: 1, codigo: "1" },
            { label: "Contribuinte Isento", value: 0, codigo: "2" },
            { label: "Não Contribuinte", value: 0, codigo: "9" },
          ].find((option) => option.codigo === data.indiedest) || null
        );
        setGeneralSendEmail(data.enviarmailcontasvencer === "S");
        setGeneralCheckBudget(data.email_utilizarorcamentovenda === "S");
        setGeneralCheckFinancial(data.email_utilizarfinanceiro === "S");
        setGeneralCheckNfe(data.email_utilizarnfe === "S");
        setGeneralDateInitial(
          data.cliente_desde ||
            formatDate({
              date: new Date(),
              separator: "-",
              format: "yyyy-mm-dd",
            })
        );
        setGeneralSendHub(!!data?.send_to_qyon_hub);
        setRuralProducer(!!data?.produtor_rural);

        //Endereços
        setBillingCep(MaskService.toMask("cep", data.cep_cobranca || ""));
        setBillingAddress(data.endereco_cobranca || "");
        setBillingNewAddress(data.endereco_cobranca.split(",")[0] || "");
        setBillingNumber(data.endereco_cobranca.split(",")[1] || "");
        setBillingComplement(data.complemento_cobranca || "");
        setBillingDistrict(data.bairro_cobranca || "");
        setDeliveryAddress(data.clientesentregas || []);
        setGeneralWebsite(data.homepage || "");

        //Contatos
        setContacts(data.clientescontatos || []);

        //Relacionados
        setMainCustomer([]);
        setDependentCustomer([]);
        setRelationship([]);
        data.dependentes.forEach((item) => {
          handleAddRelationship(item, "Dependente");
        });
        data.titulares.forEach((item) => {
          handleAddRelationship(item, "Titular");
        });

        //Autorizados
        setAuthorized(data.clientesautorizados || []);

        let tempCustomerPriceTable = [];
        data.tabelapreco?.forEach((item) => {
          if (item.pivot) {
            item.pivot.descricao = item.descricao;
            item.pivot.descontooriginal = item.descontopadrao;
            tempCustomerPriceTable.push(item.pivot);
          }
        });

        //Tabela Preco Cliente
        setCustomerPriceTable(tempCustomerPriceTable || []);

        //Info. Comerciais
        setShippingDiscount(
          MaskService.toMask("decimal", data.descontofrete || "0,00")
        );
        setDefaultDiscount(
          MaskService.toMask("decimal", data.descporc || "0,00")
        );
        setInvertDiscount(MaskService.toMask("decimal", data.diporc || "0,00"));
        setIrWithheld(
          MaskService.toMask("decimal", data.nfse_ir_porc_retido || "0,00")
        );
        setIssWithheld(
          MaskService.toMask("decimal", data.nfse_iss_porc_retido || "0,00")
        );

        //Info. Financeiras
        setHasRestriction(data.restricao === "SIM");
        setHasLimit(data.possui_limite === "SIM");
        setLastSearchSerasa1((current) => data.consultaserasa1 || current);
        setLastSearchSerasa2((current) => data.consultaserasa2 || current);
        setLastSearchSerasa3((current) => data.consultaserasa3 || current);
        setLimitValue(MaskService.toMask("decimal", data.valor_limite || ""));
        setGenerateCommission(data.geracomissao === "S");
        setFinancialObservation(data.observacao || "");
        setBillingAlert(data.alerta_faturamento || "");
        setBankInformations(data.contasbancarias || []);

        //Outras Informações
        setOtherOwnHome(
          data.casa_propria === "S"
            ? { label: "Sim", value: "S" }
            : { label: "Não", value: "N" }
        );
        setOtherBirthDate((current) => data.datanascimento || current);
        setOtherFathersName(data.nome_pai || "");
        setOtherRgFather(MaskService.toMask("rg", data.rg_pai || ""));
        setOtherCpfFather(MaskService.toMask("cpf", data.cpf_pai || ""));
        setOtherMothersName(data.nome_mae || "");
        setOtherRgMother(MaskService.toMask("rg", data.rg_mae || ""));
        setOtherCpfMother(MaskService.toMask("cpf", data.cpf_mae || ""));
        setOtherAdditionalData(data.dadosadicionais || "");
        setOtherCompanyName(data.trabalho_empresa || "");
        setOtherIssueDate((current) => data.trabalho_data_admissao || current);
        setOtherRemuneration(
          MaskService.toMask("decimal", data.trabalho_salario || "0,00")
        );
        setOtherRole(data.trabalho_funcao || "");
        setOtherTelephone(
          MaskService.toMask("cel-phone", data.trabalho_telefone || "")
        );
        setOtherAddress(data.trabalho_endereco || "");
        setOtherTypeResidence(
          [
            { label: "Própria", value: "P" },
            { label: "Alugada", value: "A" },
            { label: "Outro", value: "O" },
          ].find((type) => type.value === data.estabelecimento_tipo) || null
        );
        setOtherTimeResidence(data.estabelecimento_tempo || "");
        setOtherFamilyIncome(
          MaskService.toMask("decimal", data.renda_familiar || "0,00")
        );
        setOtherPersonalReference(data.referencia_pessoal || "");
        setOtherCommercialReference(data.referencia_comercial || "");
        setOtherNoteNfe(data.obsnfe || "");
        setOtherPartners(data.clientessocios || []);

        //Dados do Cônjuge
        setSpousesName(data.conjuge_nome || "");
        setSpousesBirthDate((current) => data.conjuge_data_nasc || current);
        setSpousesTelephone(
          MaskService.toMask("cel-phone", data.conjuge_telefone || "")
        );
        setSpousesRg(MaskService.toMask("rg", data.conjuge_rg || ""));
        setSpousesCpf(MaskService.toMask("cpf", data.conjuge_cpf || ""));
        setSpousesCompany(data.trab_conjuge_empresa || "");
        setspousesAdmissionDate(
          (current) => data.trab_conjuge_data_admissao || current
        );
        setSpousesRole(data.trab_conjuge_funcao || "");
        setSpousesRemuneration(data.trab_conjuge_salario || "0,00");
        setSpousesAddress(data.trab_conjuge_endereco || "");

        // Estabelecimentos
        const estabelecimentosRurais = (data.estabelecimentos_rurais || []).map(
          (estabelecimento) => {
            const contacts =
              Array.isArray(estabelecimento.contatos) &&
              estabelecimento.contatos[0]
                ? estabelecimento.contatos[0]
                : null;

            return {
              ...estabelecimento,
              contatos: [
                {
                  principal: contacts?.pivot?.principal || 0,
                  infoContato: {
                    id: contacts?.id || null,
                    nome: contacts?.nome || "",
                    telefone: contacts?.telefone || "",
                  },
                },
              ],
            };
          }
        );

        setRuralEstablishment(estabelecimentosRurais);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    clearCutomerContext,
    location,
    queryParams.empresa_cnpj,
    queryParams?.cliente_id,
    setAuthorized,
    setMainCustomer,
    setDependentCustomer,
    setRelationship,
    setBankInformations,
    setBillingAddress,
    setBillingNewAddress,
    setBillingNumber,
    setBillingAlert,
    setBillingCep,
    setBillingComplement,
    setBillingDistrict,
    setCommercialRegion,
    setContacts,
    setDefaultDiscount,
    setDeliveryAddress,
    setFinancialObservation,
    setGeneralActive,
    setGeneralAddress,
    setGeneralCep,
    setGeneralNewAddress,
    setGeneralNumber,
    setGeneralCheckBudget,
    setGeneralCheckFinancial,
    setGeneralCheckNfe,
    setGeneralComplement,
    setGeneralCpfCnpj,
    setGeneralCustomerId,
    setGeneralDistrict,
    setGeneralEmail,
    setGeneralFantasy,
    setGeneralWebsite,
    setGeneralFinalCustomer,
    setGeneralIe,
    setGeneralIeIndication,
    setGeneralIm,
    setGeneralCcm,
    setGeneralIsuf,
    setGeneralName,
    setGeneralRg,
    setGeneralSendEmail,
    setGeneralSimpleNational,
    setGeneralTelephone1,
    setGeneralTelephone2,
    setGeneralTelephone3,
    setGeneralTypeSubscription,
    setGenerateCommission,
    setHasLimit,
    setHasRestriction,
    setLastSearchSerasa1,
    setLastSearchSerasa2,
    setLastSearchSerasa3,
    setLimitValue,
    setLoading,
    setOtherPartners,
    setOtherAdditionalData,
    setOtherAddress,
    setOtherBirthDate,
    setOtherCommercialReference,
    setOtherCompanyName,
    setOtherCpfFather,
    setOtherCpfMother,
    setOtherFamilyIncome,
    setOtherFathersName,
    setOtherIssueDate,
    setOtherMothersName,
    setOtherNoteNfe,
    setOtherOwnHome,
    setOtherPersonalReference,
    setOtherRemuneration,
    setOtherRgFather,
    setOtherRgMother,
    setOtherRole,
    setOtherTelephone,
    setOtherTimeResidence,
    setOtherTypeResidence,
    setShippingDiscount,
    setSpousesAddress,
    setSpousesBirthDate,
    setSpousesCompany,
    setSpousesCpf,
    setSpousesName,
    setSpousesRemuneration,
    setSpousesRg,
    setSpousesRole,
    setSpousesTelephone,
    setspousesAdmissionDate,
    setIrWithheld,
    setIssWithheld,
    setCustomerPriceTable,
    handleAddRelationship,
    setGeneralDateInitial,
    setIsEmptyCpfCnpj,
    setGeneralSendHub,
    setRuralProducer,
    setRuralEstablishment,
    setValidCpfCnpj,
  ]);

  useEffect(() => {
    if (!dataCustomerEdit.idempresafrete) {
      return;
    }

    setShippingCompany(
      listCompany.find(
        (opt) => opt.id.toString() === dataCustomerEdit.idempresafrete
      ) || null
    );
  }, [dataCustomerEdit, listCompany, setShippingCompany]);

  useEffect(() => {
    if (!dataCustomerEdit.idclientematriz) {
      return;
    }

    (async () => {
      const result = await findCliente({
        empresa_cnpj: queryParams.empresa_cnpj,
        id: dataCustomerEdit.idclientematriz,
      });

      if (!result.success || !result.data || !result.data[0]) return;

      setGeneralMatriz(result.data[0] || null);
    })();
  }, [dataCustomerEdit, setGeneralMatriz, queryParams]);

  useEffect(() => {
    if (dataCustomerEdit.municipio_codigo_cobranca) {
      setBillingCounty(
        listCounty.find(
          (opt) => opt.codigo === dataCustomerEdit.municipio_codigo_cobranca
        ) || null
      );
    }

    if (dataCustomerEdit.trab_conjuge_municipio_codigo) {
      setSpousesCounty(
        listCounty.find(
          (opt) => opt.codigo === dataCustomerEdit.trab_conjuge_municipio_codigo
        ) || null
      );
    }

    if (dataCustomerEdit.trabalho_municipio_codigo) {
      setOtherCounty(
        listCounty.find(
          (opt) => opt.codigo === dataCustomerEdit.trabalho_municipio_codigo
        ) || null
      );
    }

    if (dataCustomerEdit.municipio_codigo) {
      setGeneralCounty(
        listCounty.find(
          (opt) => opt.codigo === dataCustomerEdit.municipio_codigo
        ) || null
      );
    }
  }, [
    dataCustomerEdit,
    listCounty,
    setBillingCounty,
    setGeneralCounty,
    setOtherCounty,
    setSpousesCounty,
  ]);

  useEffect(() => {
    if (dataCustomerEdit.id_estado) {
      setGeneralUf(
        listUf.find((opt) => opt.id === dataCustomerEdit.id_estado) || null
      );
    }

    if (dataCustomerEdit.id_estado_cobranca) {
      setBillingUf(
        listUf.find((opt) => opt.id === dataCustomerEdit.id_estado_cobranca) ||
          null
      );
    }
  }, [dataCustomerEdit, listUf, setBillingUf, setGeneralUf]);

  useEffect(() => {
    if (!dataCustomerEdit.idtabelafrete) {
      return;
    }

    setTableShipping(
      listTableShipping.find(
        (opt) => opt.id.toString() === dataCustomerEdit.idtabelafrete
      ) || null
    );
  }, [dataCustomerEdit, listTableShipping, setTableShipping]);

  useEffect(() => {
    if (!dataCustomerEdit.idpais) {
      return;
    }

    setGeneralNation(
      listNation.find((opt) => opt.codigo === dataCustomerEdit.idpais) || null
    );
  }, [dataCustomerEdit, listNation, setGeneralNation]);

  useEffect(() => {
    if (!dataCustomerEdit.id_tipopagamento) {
      return;
    }

    setDefaultPayment(
      listDefaultPayment.find(
        (opt) => opt.id === dataCustomerEdit.id_tipopagamento
      ) || null
    );
  }, [dataCustomerEdit, listDefaultPayment, setDefaultPayment]);

  useEffect(() => {
    if (!dataCustomerEdit.idformapagto) {
      return;
    }

    setTypePayment(
      listTypePayment.find((opt) => opt.id === dataCustomerEdit.idformapagto) ||
        null
    );
  }, [dataCustomerEdit, listTypePayment, setTypePayment]);

  useEffect(() => {
    if (!dataCustomerEdit.idvendedor) {
      return;
    }

    setSalesman(
      listSalesMan.find(
        (opt) => opt.id.toString() === dataCustomerEdit.idvendedor
      ) || null
    );
  }, [dataCustomerEdit, listSalesMan, setSalesman]);

  useEffect(() => {
    if (!dataCustomerEdit.idclasserisco) {
      return;
    }

    setRiskClass(
      listRiskClass.find((opt) => opt.id === dataCustomerEdit.idclasserisco) ||
        null
    );
  }, [dataCustomerEdit, listRiskClass, setRiskClass]);

  useEffect(() => {
    if (!dataCustomerEdit.idtransportadora) {
      return;
    }

    handleFindShippingCompany(dataCustomerEdit.idtransportadora);
  }, [dataCustomerEdit, handleFindShippingCompany]);

  useEffect(() => {
    if (!dataCustomerEdit.idparceirocomercial) {
      return;
    }

    setCommercialPartner(
      listCommercialPartner.find(
        (opt) => opt.id.toString() === dataCustomerEdit.idparceirocomercial
      ) || null
    );
  }, [dataCustomerEdit, listCommercialPartner, setCommercialPartner]);

  const getConditions = useCallback(
    () => ({
      showCondition: {
        autorizados: queryParams.guia_clientes_autorizados === "1",
        contatos: queryParams.guia_clientes_contatos === "1",
        relacionados: queryParams.colaborador === "S",
        enderecos: queryParams.guia_clientes_enderecos === "1",
        infosComerciais: queryParams.guia_clientes_infoscomerciais === "1",
        infosFinanceiras: queryParams.guia_clientes_infosfinanceiras === "1",
        utilizaTabelaPreco: queryParams.paramutilizatabelaprecos === "SIM",
        outrasInfos: queryParams.guia_clientes_outrasinfos === "1",
        validVersion: queryParams.idversao !== "16",
      },
    }),
    [
      queryParams.guia_clientes_autorizados,
      queryParams.guia_clientes_contatos,
      queryParams.guia_clientes_enderecos,
      queryParams.guia_clientes_infoscomerciais,
      queryParams.guia_clientes_infosfinanceiras,
      queryParams.paramutilizatabelaprecos,
      queryParams.guia_clientes_outrasinfos,
      queryParams.colaborador,
      queryParams.idversao,
    ]
  );

  const { showCondition } = getConditions();

  useEffect(() => {
    if (!dataCustomerEdit.regiaocomercial) {
      return;
    }

    setCommercialRegionSelect(
      listCommercialRegion.find(
        (opt) => opt.id.toString() === dataCustomerEdit.regiaocomercial
      ) || ""
    );
  }, [dataCustomerEdit, listCommercialRegion, setCommercialRegionSelect]);

  return (
    <>
      <HeaderModule
        title="CADASTRO DE CLIENTES"
        videoId={GlobalVariables.screenVideosIds.cadastroCliente}
      />

      <Loading open={loading} />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={3}>
          <AccordionClienteDadoGeral />
          {ruralProducer && <AccordionRuralEstablishment />}
          {showCondition.enderecos && <AccordionClienteEndereco />}
          {showCondition.contatos && <AccordionClienteContato />}
          {showCondition.autorizados && <AccordionClienteAutorizado />}
          {showCondition.relacionados && <AccordionClienteRelacionado />}
          {showCondition.infosComerciais && <AccordionClienteInfoComercial />}
          {showCondition.infosComerciais &&
            showCondition.utilizaTabelaPreco && <AccordionClienteTabelaPreco />}
          {showCondition.infosFinanceiras && <AccordionClienteInfoFinanceira />}
          {showCondition.validVersion && showCondition.outrasInfos && (
            <AccordionClienteOutrasInfo />
          )}
        </Grid>

        <Grid
          item
          container
          justifyContent="flex-end"
          style={{ marginTop: 20, marginBottom: 20 }}
          spacing={1}
        >
          <Grid item>
            <Btn label="Voltar" bgcolor="tertiary" onClick={handleBackSubmit} />
          </Grid>
          {(!generalCustomerId || generalCustomerId !== 1) && (
            <>
              <Grid item>
                <Btn label="Salvar" onClick={() => handleSubmit(false)} />
              </Grid>
              <Grid item>
                <Btn label="Salvar e Novo" onClick={() => handleSubmit(true)} />
              </Grid>
            </>
          )}
        </Grid>
      </PainelContainer>
    </>
  );
};

const ClienteCadastro = ({ ...props }) => (
  <ClienteContextProvider>
    <View {...props} />
  </ClienteContextProvider>
);

export default ClienteCadastro;
